<template>
  <g fill-rule="evenodd">
    <path
      d="M19 8.4L10 1.2a.8.8 0 00-1 0L.3 8.4a.8.8 0 001 1.2l1.1-.9v7.5c0 1.3 1 2.4 2.4 2.4h9.6c1.3 0 2.4-1 2.4-2.4V8.7l1 1A.8.8 0 0019 8.3z"
    />
    <path
      d="M15.2 16.2c0 .4-.4.8-.8.8h-1.6v-4c0-1.3-1-2.4-2.4-2.4H8.8c-1.3 0-2.4 1-2.4 2.4v4H4.8a.8.8 0 01-.8-.8V7.4l5.6-4.6 5.6 4.6v8.8z"
      class="secondary-color"
    />
    <path d="M8 17v-4c0-.4.4-.8.8-.8h1.6c.4 0 .8.4.8.8v4H8z" class="secondary-color" />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeIcon",
});
</script>
